export const apexQueryKeys = {
  _base: () => ["apex"],
  all: (agencyId: string) => [...apexQueryKeys._base(), { agencyId }],
  branches: (agencyId: string) => [...apexQueryKeys.all(agencyId), "branches"],
};
